import { useRef } from "react";
import { isArrayEqual } from "../util/equal.js";
import { Starter } from "../util/start.js";
export function useMount(start, ...args) {
    const internals = (useRef().current ||= {
        args,
        current: null,
        starter: new Starter(start),
        ref(next) {
            if (internals.current !== next) {
                internals.current = next;
                internals.starter.stop();
                if (internals.current)
                    internals.starter.start(internals.current, ...internals.args);
            }
        },
    });
    if (!isArrayEqual(args, internals.args)) {
        internals.args = args;
        internals.starter.stop();
        if (internals.current)
            internals.starter.start(internals.current, ...internals.args);
    }
    return internals.ref;
}
